// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CarListing from './components/Car/CarListing';
import CarDetails from './components/Car/CarDetails';
import Login from './components/Auth/Login';
import Logout from './components/Auth/Logout';
import CarSourcingForm from './components/Sourcing/CarSourcingForm';
import TermsAndConditions from './components/Sourcing/TermsAndConditions';
import PaymentPage from './components/Payment/PaymentPage';
import Navbar from './components/Navbar';
import BikeList from './components/Bikes/BikeList';
import BikeDetails from './components/Bikes/BikeDetails';
import About from './pages/About';
import Contact from './pages/Contact';
import Vehicles from './pages/Vehicles';
import SearchResults from './pages/SearchResults';
import HomePage from './pages/HomePage';
import Footer from './pages/Footer';
import PaymentSuccess from './components/Payment/PaymentSuccess';

import './App.css'; // Assuming you have a global CSS file

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  const toggleTheme = () => {
    setIsDarkMode((prevMode) => !prevMode);
  };

  return (
    <Router>
      <div className={isDarkMode ? 'dark-mode' : 'light-mode'}>
        <Navbar toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/cars" element={<CarListing />} />
          <Route path="/cars/:id" element={<CarDetails />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/sourcing" element={<CarSourcingForm />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/payment" element={<PaymentPage />} /> {/* New payment page route */}
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/vehicles" element={<Vehicles />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/bikes" element={<BikeList />} />
          <Route path="/bikes/:id" element={<BikeDetails />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
